import { TENANT, Tenant } from './tenant';

const defaultTenantWebsite = 'https://avelios.com';

/**
 * Mapping of tenants to their website.
 */
const tenantToWebsiteMap = new Map<Tenant, string>([
  [Tenant.avelios, defaultTenantWebsite],
  [Tenant.sana, 'https://www.sana.de/'],
]);

/**
 * Tenant website. Use this const in all places where the website has to be linked.
 * E.g. footer, navbar
 */
export const TENANT_WEBSITE: string = ((tenant: Tenant) => {
  const tenantWebsite = tenantToWebsiteMap.get(tenant);

  if (tenantWebsite) {
    return tenantWebsite;
  }

  console.warn(`No website defined for tenant ${tenant}. Falling back to default.`);
  return defaultTenantWebsite;
})(TENANT);
